module.exports = __webpack_public_path__ + "static/img/tab6.6e550a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab6.png
// module id = VG3z
// module chunks = 0